<template>
	<h3 class="title mb_20 tal">{{ $t('c2c.search.title') }}</h3>
	<div class="search_area mb_20">
		<input
			v-model="searchKeyword"
			type="text"
			:placeholder="$t('input.placeholder.search_assets')"
			autofocus
		/>
		<a class="search_icon SEARCH"></a>
	</div>

	<div class="asset_list_wrap">
		<div v-if="recentSearchAssets.length > 0" class="recent">
			<div class="d_flex justify_between mb_10">
				<h4>{{ $t('c2c.search.head2') }}</h4>
				<a class="delete" @click="removeSearchHistory('ALL')">{{
					$t('c2c.search.delete')
				}}</a>
			</div>
			<ul class="d_flex">
				<li
					class="asset_box item"
					v-for="item in recentSearchAssets"
					:key="item.seq"
					@click="selectAsset(item.seq)"
				>
					<span :class="[item.code, 'small']"></span>
					<p class="code mr_4">{{ item.code }}</p>
					<p class="name">{{ item.title }}</p>
					<span
						class="icon CANCEL"
						@click.stop="removeSearchHistory(item.seq)"
					></span>
				</li>
			</ul>
		</div>
		<div class="result">
			<h4 class="mb_10">{{ subTitle }}</h4>
			<ul v-if="sourceAssets.length > 0" class="d_flex">
				<li
					class="asset_box item"
					v-for="item in sourceAssets"
					:key="item.seq"
					@click="selectAsset(item.seq)"
				>
					<span :class="[item.code, 'small']"></span>
					<p class="code mr_4">{{ item.code }}</p>
					<p class="name">{{ item.title }}</p>
				</li>
			</ul>
			<p v-else>{{ $t('c2c.search.empty') }}</p>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { filter, uniqBy } from 'lodash';

export default {
	name: 'AssetSearch',
	emits: ['selectAsset'],
	props: {
		markets: Array,
		default: () => [],
	},
	data() {
		return {
			recentSearchAssetKey:
				'p2p_recentSearch_' + this.$store.state.auth.member_info.seq,
			searchKeyword: '',
			recentSearchAssetsSeq: [],
		};
	},
	computed: {
		...mapGetters('assets', ['assets']),
		subTitle() {
			return this.searchKeyword
				? this.$t('c2c.search.head3')
				: this.$t('c2c.search.head1');
		},
		sourceAssets() {
			let result = [];
			this.markets.forEach(market => {
				const asset = this.assets.find(asset => {
					return asset.seq === market.source_asset_seq;
				});
				if (asset) result.push(asset);
			});
			result = uniqBy(result, 'seq');
			if (this.searchKeyword) {
				return filter(result, item => {
					return (
						item.code
							.toLowerCase()
							.includes(this.searchKeyword.toLowerCase()) ||
						item.title.toLowerCase().includes(this.searchKeyword.toLowerCase())
					);
				});
			} else {
				return result;
			}
		},
		recentSearchAssets() {
			const result = [];
			this.recentSearchAssetsSeq.forEach(seq => {
				const asset = this.assets.find(asset => {
					return asset.seq === seq;
				});
				if (asset) result.push(asset);
			});
			return result;
		},
	},
	mounted() {
		if (localStorage.getItem(this.recentSearchAssetKey)) {
			this.recentSearchAssetsSeq = JSON.parse(
				localStorage.getItem(this.recentSearchAssetKey),
			);
			this.recentSearchAssetsSeq = this.recentSearchAssetsSeq.filter(recent => {
				return this.markets.find(market => {
					return market.source_asset_seq === recent;
				});
			});
		}
	},
	methods: {
		selectAsset(assetSeq) {
			this.saveSearchHistory(assetSeq);
			this.$emit('selectAsset', assetSeq);
		},
		saveSearchHistory(assetSeq) {
			const index = this.recentSearchAssetsSeq.indexOf(assetSeq);
			if (index === -1) {
				this.recentSearchAssetsSeq.unshift(assetSeq);
				if (this.recentSearchAssetsSeq.length > 6) {
					this.recentSearchAssetsSeq.pop();
				}
				localStorage.setItem(
					this.recentSearchAssetKey,
					JSON.stringify(this.recentSearchAssetsSeq),
				);
			}
		},
		removeSearchHistory(assetSeq) {
			if (assetSeq === 'ALL') {
				this.recentSearchAssetsSeq = [];
			} else {
				const index = this.recentSearchAssetsSeq.indexOf(assetSeq);
				this.recentSearchAssetsSeq.splice(index, 1);
			}
			localStorage.setItem(
				this.recentSearchAssetKey,
				JSON.stringify(this.recentSearchAssetsSeq),
			);
		},
	},
};
</script>

<style scoped></style>
